import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './ProfilePage.css';

const ProfilePage = () => {
  const { isAuthenticated, user, updateProfile, refreshUser } = useAuth();
  const [displayName, setDisplayName] = useState(user?.display_name || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // コンポーネントのマウント時に最新のユーザー情報を取得
  useEffect(() => {
    const fetchLatestUserInfo = async () => {
      await refreshUser();
    };
    fetchLatestUserInfo();
  }, [refreshUser]);

  // userが変更されたときにdisplayNameを更新
  useEffect(() => {
    if (user) {
      setDisplayName(user?.display_name || '');
    }
  }, [user]);

  // ログインしていない場合はログインページにリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    const updateData = {
      display_name: displayName,
    };

    // パスワード変更がある場合のみ追加
    if (newPassword) {
      if (!currentPassword) {
        setError('新しいパスワードを設定する場合は、現在のパスワードを入力してください');
        setLoading(false);
        return;
      }
      updateData.current_password = currentPassword;
      updateData.new_password = newPassword;
    }

    const result = await updateProfile(updateData);

    if (result.success) {
      setSuccess('プロフィールを更新しました');
      setCurrentPassword('');
      setNewPassword('');
    } else {
      setError(result.error || 'プロフィールの更新に失敗しました');
    }

    setLoading(false);
  };

  return (
    <div className="page">
      <div className="profile-container">
        <div className="profile-form">
          <h2>プロフィール設定</h2>

          {error && <div className="error-message">{error}</div>}
          {success && <div className="success-message">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">メールアドレス</label>
              <input
                type="email"
                id="email"
                value={user?.email || ''}
                disabled
                className="readonly-input"
              />
              <small className="form-text">メールアドレスは変更できません</small>
            </div>

            <div className="form-group">
              <label htmlFor="displayName">表示名</label>
              <input
                type="text"
                id="displayName"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="表示名を入力してください"
                disabled={loading}
              />
              <small className="form-text">カレンダーに表示される名前です</small>
            </div>

            <div className="form-section">
              <h3>パスワード変更</h3>

              <div className="form-group">
                <label htmlFor="currentPassword">現在のパスワード</label>
                <input
                  type="password"
                  id="currentPassword"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="現在のパスワード"
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="newPassword">新しいパスワード</label>
                <input
                  type="password"
                  id="newPassword"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="新しいパスワード"
                  disabled={loading}
                />
                <small className="form-text">パスワードを変更する場合のみ入力してください</small>
              </div>
            </div>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? '保存中...' : '保存'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
